import OwButton from "@components/shared/OwButton/OwButton";
import IOrder from "@models/IOrder";
import { useContext, useEffect, useState } from "react";
import { AuthorizeNetContext } from "@contexts/AuthorizeNetContext";
import { SocketContext } from "@contexts/SocketContext";
import { DispatchDataResponse } from "react-acceptjs";
import IUiSocketSetup from "@models/IUiSocketSetup";
import SupplierContext from "@contexts/SupplierContext";
import EndpointsEnum from "@models/EndpointsEnum";
import UserContext from "@contexts/UserContext";
import VendorContext from "@contexts/VendorContext";
import IAuthNetOnAuthAndCaptureCreditCardDTO from "@models/DTO/IAuthNetOnAuthAndCaptureCreditCardDTO";
import IAuthNetAcceptAuthAndCaptureCreditCardDTO from "@models/DTO/IAuthNetAcceptAuthAndCaptureCreditCardDTO";
import UiContext from "@contexts/UiContext";
import INotification from "@models/INotification";
import NotificationLevelEnum from "@models/NotificationLevelEnum";
import NotificationPositionEnum from "@models/NotificationPositionEnum";

type Props = {
    orderModel: IOrder;
    confirmFn: () => void;
};

export const OrderPaymentAuthorizeNetCompleted = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const vendorModel = useContext(VendorContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [isProcessing, setIsProcessing] = useState(false);

    const {existingCard, newPaymentDetails, isLoading, setIsLoading, nextSlide, prevSlide} = useContext(AuthorizeNetContext);
    
    const authNetOnAcceptAuthAndCaptureCreditCard = (data: IAuthNetOnAuthAndCaptureCreditCardDTO) => {
        // how to test if an error??
        if (data) {
            const notification: INotification = {
                message: "payment_successful",
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
            }
            
            uiContext.notifyFn(null, notification);

            props.confirmFn();
        }

        setIsProcessing(false);
    }

    const notify = () => {
        setIsProcessing(false);
    }


    const sockets: IUiSocketSetup[] = [
        {endpoint: EndpointsEnum.AuthNetOnAcceptAuthAndCaptureCreditCard, fn: authNetOnAcceptAuthAndCaptureCreditCard},
        {endpoint: EndpointsEnum.Notify, fn: notify},
    ]

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        }
    }, []);

    const updateOrder = (details: DispatchDataResponse) => {
        const payload: IAuthNetAcceptAuthAndCaptureCreditCardDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            orderGuid: props.orderModel.guid,
            amount: props.orderModel.grand_total || 0,
            opaqueData: {
                dataDescriptor: details.opaqueData.dataDescriptor,
                dataValue: details.opaqueData.dataValue,
            }
        }

        socket.emit(EndpointsEnum.AuthNetAcceptAuthAndCaptureCreditCard, payload);

        setIsProcessing(true);
    }

    const completePayment = () => {
        if (newPaymentDetails) {
            updateOrder(newPaymentDetails);
        } else {
            const notification: INotification = {
                message: "payment_details_not_found",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            }
            
            uiContext.notifyFn(null, notification);
        }
    }

    return <div className={"OrderPaymentAuthorizeNetCompleted"}>
        <div className="d-flex justify-content-center mt-5">
            <OwButton title="complete" fn={() => { completePayment() }} active={isProcessing} disableOnActive={true}/>
        </div>
        <div className="d-flex justify-content-center mt-5">
            <OwButton title="prev" fn={() => { prevSlide() }} disabled={isProcessing}/>
        </div>
    </div>;
};
